import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'

import reportWebVitals from './reportWebVitals';

import './index.css';
import 'antd/dist/antd.min.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { OrgProvider } from './context/OrgContext';
import { Auth0provider } from './config/Auth0provider';
import { DBAProvider } from './context/DbaContext';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  // <React.StrictMode>
  <BrowserRouter>
    <AuthProvider>
      <OrgProvider>
        <Auth0provider>
          <DBAProvider>
            <App />
          </DBAProvider>
        </Auth0provider>
      </OrgProvider>
    </AuthProvider>
  </BrowserRouter>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
